import React from "react";
import { Platform, ScrollView, View } from "react-native";

import { AHButton, AHIcon, AHInput, Card, ListItem, TouchableBox } from "arkh";
import * as DocumentPicker from "expo-document-picker";
import * as FileSystem from "expo-file-system/legacy";
import { graphql, useMutation } from "react-relay";
import { ActivatePLUFromStoreFilesScreenMutation } from "./__generated__/ActivatePLUFromStoreFilesScreenMutation.graphql";
import { useAlert } from "../../common/Alert";
import { withWebModalStack } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModalStack";
type FileType = {
  name: string;
  base64: string;
};
export const ActivatePLUFromStoreFilesScreen = withWebModalStack(
  ActivatePLUFromStoreFilesScreenC
);
function ActivatePLUFromStoreFilesScreenC() {
  const [files, setFiles] = React.useState<FileType[]>([]);
  const [uploadMutation, loading] =
    useMutation<ActivatePLUFromStoreFilesScreenMutation>(graphql`
      mutation ActivatePLUFromStoreFilesScreenMutation(
        $files: [ActivatePLUFileInput!]!
      ) {
        activatePLUFromStoreOfficeFile(files: $files) {
          pluCategories {
            id
          }
        }
      }
    `);

  const Alert = useAlert();

  const upload = () => {
    uploadMutation({
      onCompleted: () => {
        setFiles([]);
        Alert.alert("Success", "Files imported");
      },
      onError: (e) => {
        Alert.alert("Error", e.message);
      },
      variables: {
        files: files.map((file) => ({
          name: file.name,
          fileBase64: file.base64,
        })),
      },
    });
  };

  return (
    <>
      <Card>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <AHButton
            title="Add file"
            onPress={() => {
              DocumentPicker.getDocumentAsync({
                copyToCacheDirectory: true,

                multiple: true,
                type: [
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  "application/vnd.ms-excel",
                  "application/xls",
                  "application/xlsx",
                ],
              }).then((result) => {
                if (result.canceled) return;

                if (Platform.OS === "web") {
                  for (const file of result.output!) {
                    const reader = new FileReader();
                    reader.onload = () => {
                      // Use a regex to remove data url part
                      if (reader.result) {
                        const base64String = (reader.result as any)
                          .replace("data:", "")
                          .replace(/^.+,/, "");

                        setFiles((prev) => [
                          ...prev,
                          {
                            name: file.name
                              .replace(".xls", "")
                              .replace(".xlsx", ""),
                            base64: base64String,
                          },
                        ]);
                      }
                    };

                    reader.readAsDataURL(file);
                  }
                } else {
                  FileSystem.readAsStringAsync((result as any).uri, {
                    encoding: FileSystem.EncodingType.Base64,
                  }).then((base64) => {
                    setFiles([
                      ...files,
                      {
                        name: (result as any).name
                          .replace(".xls", "")
                          .replace(".xlsx", ""),
                        base64,
                      },
                    ]);
                  });
                }
              });
            }}
          />
          <AHButton title="Upload" onPress={upload} loading={loading} />
        </View>
      </Card>
      <ScrollView>
        {files.map((file, i) => (
          <ListItem
            key={i}
            right={
              <TouchableBox
                space="small"
                hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
                onPress={() => {
                  setFiles((oldFiles) => oldFiles.filter((f, oi) => oi !== i));
                }}
              >
                <AHIcon type="remove-outline" color="negative" />
              </TouchableBox>
            }
          >
            <AHInput
              color="background"
              space="large"
              cornerRadius="large"
              value={file.name}
              onChangeText={(t) => {
                setFiles((oldFiles) =>
                  oldFiles.map((f, oi) => {
                    if (oi === i) {
                      return { ...f, name: t };
                    }
                    return f;
                  })
                );
              }}
            />
          </ListItem>
        ))}
      </ScrollView>
    </>
  );
}
